import { generatePermissionForEntity } from '../util';
export var MerchantPermissions;
(function (MerchantPermissions) {
    MerchantPermissions["WEB_READ_HOME_PAGE"] = "WEB_READ_HOME_PAGE";
    MerchantPermissions["TEAMS_PAGE_VIEW"] = "TEAMS_PAGE_VIEW";
    MerchantPermissions["SETTINGS_PAGE_VIEW"] = "SETTINGS_PAGE_VIEW";
    MerchantPermissions["NAVBAR_VIEW"] = "NAVBAR_VIEW";
    MerchantPermissions["HOME_PAGE_VIEW"] = "HOME_PAGE_VIEW";
    MerchantPermissions["FEATURES_SETUP_PAGE_VIEW"] = "FEATURES_SETUP_PAGE_VIEW";
    MerchantPermissions["LOCATIONS_PAGE_VIEW"] = "LOCATIONS_PAGE_VIEW";
    MerchantPermissions["REPORTS_PAGE_VIEW"] = "REPORTS_PAGE_VIEW";
    MerchantPermissions["CUSTOMER_PAGE_VIEW"] = "CUSTOMER_PAGE_VIEW";
    MerchantPermissions["PROMOTION_PAGE_VIEW"] = "PROMOTION_PAGE_VIEW";
    MerchantPermissions["LOYALTY_PAGE_VIEW"] = "LOYALTY_PAGE_VIEW";
    MerchantPermissions["AUDIENCES_PAGE_VIEW"] = "AUDIENCES_PAGE_VIEW";
    MerchantPermissions["GIFT_CARDS_PAGE_VIEW"] = "GIFT_CARDS_PAGE_VIEW";
})(MerchantPermissions || (MerchantPermissions = {}));
export const MERCHANT_PERMISSIONS = generatePermissionForEntity('MERCHANT', MerchantPermissions);
//# sourceMappingURL=merchant.js.map